var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shell"},[_c('div',{staticClass:"Carousel"},[_c('img',{attrs:{"src":_vm.bannerList.banner}})]),_c('div',{staticClass:"music"},_vm._l((_vm.DemoseaList),function(item,index){return _c('div',{key:index,staticClass:"listbox"},[_c('DemoSea',{attrs:{"DemoseaList":item,"creatType":"none"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }